import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RegistrationModal from '../../RegistrationModal';
import { analyticsTrack } from '../../../analyticsUtils';
import './GetStartedCTA.scss';

function GetStartedCTA({
  csrfToken,
  googleOmniauthUrl,
  msOmniauthUrl,
  signInUrl,
  location,
  projectResourceId,
  inviterId,
}) {
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);

  return (
    <div className="get-started-cta">
      Ready to find your consultant?
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => {
          setShowRegistrationModal(true);
          analyticsTrack('Clicked on get started', { location });
        }}
      >
        Get Started
      </button>
      <RegistrationModal
        csrfToken={csrfToken}
        showModal={showRegistrationModal}
        hideModal={() => setShowRegistrationModal(false)}
        googleOmniauthUrl={googleOmniauthUrl}
        msOmniauthUrl={msOmniauthUrl}
        signInUrl={signInUrl}
        showTestimonials={false}
        location={location}
        inviterId={inviterId}
        projectResourceId={projectResourceId}
      />
    </div>
  );
}

GetStartedCTA.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  location: PropTypes.string,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string,
};

GetStartedCTA.defaultProps = {
  location: 'Projects page',
  inviterId: null,
  projectResourceId: null,
};
export default GetStartedCTA;
